var e=function(e,n){return e.slice(0,n.length)===n};export{e as stringStartsWith};
//# sourceMappingURL=stringStartsWith.js.map
